package org.example.project.service

import kotlinx.serialization.Serializable
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All

@Serializable
data class YardFlowTimelinePoint(
    val id: String = "",
    val key: String = "",
    val label: String = "",
    val aktiv: Boolean = false,
    val erledigt: Boolean = false,
    val zustand: Int = 0,
    val datum: String = "",
    val uhrzeit: String = ""
)

@Serializable
data class YardFlowDocument(
    val id: String = "",
    val name: String = "",
    val file: String = "",
    val source: String = "",
    val serviceType: String = "",
    val entryId: String = "",
    val lieferscheinnummer: String = "",
    val erstelltAm: String = "",
    val erstelltUm: String = "",
    val openUrl: String = "",
    val downloadUrl: String = ""
)

@Serializable
data class YardFlowTimelineRow(
    val id: String = "",
    val flowId: String = "",
    val flowTyp: String = "",
    val sourceFirmenId: String = "",
    val sourceWaTour: String = "",
    val sourceWaLkwId: String = "",
    val targetFirmenId: String = "",
    val targetWeId: String = "",
    val lieferscheinnummer: String = "",
    val palettenanzahl: Int = 0,
    val fahrername: String = "",
    val lkwkennzeichen: String = "",
    val status: String = "",
    val sichtModus: String = "",
    val canSeeWa: Boolean = false,
    val canSeeWe: Boolean = false,
    val beteiligteFirmenIds: List<String> = emptyList(),
    val punkte: List<YardFlowTimelinePoint> = emptyList(),
    val dokumente: List<YardFlowDocument> = emptyList(),
    val waVorhanden: Boolean = false,
    val weVorhanden: Boolean = false
)

object YardFlowTimelineApi {
    private const val EMPTY_FIELD = "~"

    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadFlows(firmenId: String = ""): List<All> {
        val raw = runCatching {
            LumaticaApiManager.call("yardflow/flows/${apiPart(firmenId)}")
        }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return emptyList()
        return runCatching {
            json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw)
        }.getOrDefault(emptyList())
    }

    suspend fun loadFlowRows(firmenId: String = ""): List<YardFlowTimelineRow> {
        val raw = runCatching {
            LumaticaApiManager.call("yardflow/flows/${apiPart(firmenId)}")
        }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return emptyList()
        return runCatching {
            json.decodeFromString(ListSerializer(YardFlowTimelineRow.serializer()), raw)
        }.getOrDefault(emptyList())
    }

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(if (value.isBlank()) EMPTY_FIELD else value) as String
}
